import * as React from "react";
import { LoaderScreen } from "@grandvisionhq/common";
import { useConfiguratorContext } from "@grandvisionhq/configurator";
import { useDispatch, useSelector, statusSuccess } from "@grandvisionhq/state";
import "../../../../state/state/actions.js";
import "../../../../state/add-to-cart/state/add-to-cart/selectors.js";
import "../../../../state/bundles/state/bundles/selectors.js";
import "../../../../state/bundles/state/bundles/reducer.js";
import { getSelectedFrame, getLensTypes, getSelectedLensType } from "../../../../state/configurator/state/configurator/selectors.js";
import "../../../../state/configurator/state/configurator/reducer.js";
import "../../../../state/products/state/products/selectors.js";
import "../../../../state/products/state/products/reducer.js";
import { getSelectedVariantParentSku } from "../../../../utils/utils/get-selected-variant-parent-sku.js";
import { ProductSelectionStep } from "../../../components/ProductSelectionStep/steps/components/ProductSelectionStep/ProductSelectionStep.js";
import { selectLensType } from "../../../../state/configurations/state/configurations/actions.js";
const LensTypeStepContainer = () => {
  const dispatch = useDispatch();
  const { goToNextStep } = useConfiguratorContext();
  const frame = useSelector(getSelectedFrame);
  const lensTypes = useSelector(getLensTypes);
  const selectedLensType = useSelector(getSelectedLensType);
  const onChange = React.useCallback(
    (sku) => {
      if (!frame) {
        return;
      }
      dispatch(
        selectLensType({
          frameSku: frame.sku,
          lensTypeSku: sku,
          reason: "user selection"
        })
      );
    },
    [dispatch, frame?.sku]
  );
  if (!statusSuccess(lensTypes)) {
    return /* @__PURE__ */ React.createElement(LoaderScreen, null);
  }
  const lensTypeList = lensTypes.result;
  let selectedLensTypeParentSku;
  if (selectedLensType) {
    selectedLensTypeParentSku = getSelectedVariantParentSku(lensTypeList, selectedLensType?.sku);
  }
  return /* @__PURE__ */ React.createElement(
    ProductSelectionStep,
    {
      onChange,
      onSubmit: goToNextStep,
      itemsList: lensTypeList,
      selectedItemSku: selectedLensTypeParentSku || selectedLensType?.sku,
      step: "lensType"
    }
  );
};
export {
  LensTypeStepContainer
};
//# sourceMappingURL=LensTypeStepContainer.js.map
